// src/redux/api/operationsThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setOperation } from './operationsSlice';
import {Operation} from "../../../types";
import {fetchData} from "../../../services/data-service";
import {OPERATIONS_ENDPOINT} from "../../../services/utils/api-consts";

// Thunk: регулярный опрос сервера для обновления статуса операции.
export const pollOperationStatus = createAsyncThunk<
    Operation,           // Тип результата (fulfilled)
    string,              // Тип аргумента (operationId)
    { rejectValue: string }
>(
    'operations/pollOperationStatus',
    async (operationId, { rejectWithValue, dispatch }) => {
        // вспомогательная функция "sleep"
        const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

        try {
            let op: Operation;

            while (true) {
                // 1) получаем статус операции
                op = await fetchData<Operation>(`${OPERATIONS_ENDPOINT}${operationId}`);

                // 2) диспатчим обновление в store
                dispatch(setOperation(op));
                if (op.status !== 'InProgress') {
                    break;
                }
                await delay(500);
            }

            return op;  // fulfilled
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

